"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = exports.paramsSchema = exports.SIZE_LIMIT = exports.ERRORS = exports.SUBTITLE_MAX_LENGTH = exports.TITLE_MAX_LENGTH = void 0;
var yup = __importStar(require("yup"));
var constants_1 = require("../../../../constants");
exports.TITLE_MAX_LENGTH = 30;
exports.SUBTITLE_MAX_LENGTH = 33;
exports.ERRORS = {
    REQUIRED: 'Required!',
    MAX_LENGTH: 'Max length limit exceeded',
    FILE_IS_NOT_AN_IMAGE: 'File is not an image',
    UNSUPPORTED_FILE_FORMAT: 'Unsupported file format',
    FILE_SIZE_LIMIT: 'FILE_SIZE_LIMIT',
};
var MB = 1024 * 1024;
exports.SIZE_LIMIT = 5 * MB;
exports.paramsSchema = yup.object().shape({
    title: yup.string().max(exports.TITLE_MAX_LENGTH, exports.ERRORS.MAX_LENGTH).required(exports.ERRORS.REQUIRED),
    subtitle: yup.string().max(exports.SUBTITLE_MAX_LENGTH, exports.ERRORS.MAX_LENGTH).required(exports.ERRORS.REQUIRED),
    coverImage: yup
        .mixed()
        .test('content_type', exports.ERRORS.FILE_IS_NOT_AN_IMAGE, function (value) {
        var _a;
        var imageMagicNumber = {
            jpg: 'ffd8ffe0',
            jpg1: 'ffd8ffe1',
            jpg2: 'ffd8ffe2',
            jpg3: 'ffd8ffe8',
            png: '89504e47',
        };
        return value && typeof value === 'object'
            ? value.buffer
                ? Object.values(imageMagicNumber).includes((_a = value.buffer) === null || _a === void 0 ? void 0 : _a.toString('hex', 0, 4))
                : true
            : true;
    })
        .test('mimetype', exports.ERRORS.UNSUPPORTED_FILE_FORMAT, function (value) {
        return value && typeof value === 'object'
            ? ['image/png', 'image/jpeg'].includes(value.mimetype || value.type)
            : true;
    })
        .test('size', exports.ERRORS.FILE_SIZE_LIMIT, function (value) {
        return value && typeof value === 'object' ? value.size <= exports.SIZE_LIMIT : true;
    })
        .required(exports.ERRORS.REQUIRED),
});
exports.ROUTE = constants_1.routes.PUBLIC_GENERATE_ITEM;
//# sourceMappingURL=params.js.map